var map = {
	"./boy_black_specs.png": "ced4",
	"./boy_black_stache.png": "16c4",
	"./boy_white_earphones_hoodie.png": "ddbc",
	"./boy_white_futuristic_brown.png": "23b5",
	"./default.png": "da9a",
	"./girl_black_earrings.png": "c196",
	"./girl_black_mask.png": "d3d1",
	"./girl_white.png": "5dba",
	"./girl_white_green.png": "64a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31cf";